import styled, { css } from 'styled-components';
import { zindex } from 'src/ui/zindex';
import { layout } from 'src/components/base';
import { DropdownToggle } from '@prisjakt/ui/dropdown';

type ActionButtonProps = {
  $marginRem: number;
};

export const StyledActionButton = styled.div<ActionButtonProps>(
  props => css`
    position: absolute;
    top: ${props.$marginRem}rem;
    right: ${props.$marginRem}rem;
    display: flex;
    flex-direction: column;
    z-index: ${zindex.actionButtonDropdown};

    > *:not(:first-child) {
      margin-top: ${layout.measurements.spacing100};
    }
  `
);

export const StyledListButton = styled.button`
  display: flex;
  gap: ${layout.measurements.spacing050};
  white-space: nowrap;
  cursor: pointer;
  padding: ${layout.measurements.spacing050};

  &:hover {
    background: ${p => p.theme.dropdowns.secondary.hoverBackground};
  }
`;

export const StyledToggle = styled(DropdownToggle)`
  background: ${props => props.theme.bg.primary};
`;
